module.exports = __webpack_public_path__ + "static/reel-sun-e47cf3a450698a6a8e1f075db2e43a63.mp4";